import {
  Box,
  Button,
  MenuItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import { GET_BLOG_ARTICLES } from '../../../../graphql/queries';
import { useAlert } from '../../../../hooks';
import { useRemoveBlogArticleMutation } from '../../../../hooks/useMutations';
import { styles } from './styles';

const DeleteBlogModal = ({ blogData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { showAlert } = useAlert();
  const [removeBlogArticleMutation] = useRemoveBlogArticleMutation();

  const handleDeleteReview = () => {
    removeBlogArticleMutation({
      variables: {
        /* eslint-disable-next-line no-underscore-dangle */
        id: blogData?._id,
      },
      onCompleted: () => {
        showAlert({
          message: 'Блог успешно удалён.',
          variant: 'info',
        });
      },
      onError: () => {
        showAlert({
          message: 'Произошла ошибка при удалении блога!',
          variant: 'error',
        });
      },
      refetchQueries: [GET_BLOG_ARTICLES],
    });
    onClose();
  };

  return (
    <>
      <MenuItem sx={styles.menuDeleteText} onClick={onOpen}>
        Удалить
      </MenuItem>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Удаление</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <Text>Вы действительно хотите удалить блог?</Text>
              <Box>
                <Box sx={styles.modalTextWrapper}>
                  <Text fontSize='xl' mr='0.5vw' minW='3.5vw'>
                    Название:
                  </Text>
                  <Text>{blogData?.title}</Text>
                </Box>
                <Box sx={styles.modalTextWrapper}>
                  <Text fontSize='xl' mr='0.5vw' minW='3.5vw'>
                    ID:
                  </Text>
                  {/* eslint-disable-next-line no-underscore-dangle */}
                  <Text>{blogData?._id}</Text>
                </Box>
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant='solid' colorScheme='red' mr={3} onClick={handleDeleteReview}>
              Удалить
            </Button>
            <Button colorScheme='blue' onClick={onClose}>
              Отмена
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteBlogModal;
